import { Observable } from 'rx';
import CTLiveApi from 'ctliveapi-configured';
import _ from 'lodash';
/**
 * Periodically hits ctlive for new results and panel settings changes.
 * @param  {Object} params Reoute parameters.
 * @return {RxJS.Observable}
 */
export function getScrollingResults({ params }) {
  return Observable.just(params.panel)
    .flatMap((panel) => {
      return Observable.timer(0, 10000).timeInterval().flatMap(() =>
        Observable.onErrorResumeNext(
          CTLiveApi.getScrollingResults(panel, {
            'lc': params.lc || 'en',
            'preview': params.preview || 0
          }).map((data) => _.assign({}, data.response, { isLoading: false }))
        )
      )
    })
}



// WEBPACK FOOTER //
// ./streams/getScrollingResults.js